import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';

import { Profile } from '@df/interfaces';
import { AccountService } from '@teacher/services/account.service';
import { AppConfigsService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-notification-settings',
    templateUrl: './notifications-settings.component.html',
    styleUrls: ['./notifications-settings.component.scss']
})
export class NotificationsSettingsComponent implements OnInit, OnDestroy {
    profile: Profile;
    authCodeForm: FormGroup;
    isUpdateTelegramSettings = false;
    isUpdateEmailSettings = true;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private handlerService: HandlerService,
        private accountService: AccountService,
        private appConfigsService: AppConfigsService
    ) {}

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.profile = data['profile'].data;
        });

        this.authCodeForm = this.fb.group({
            authCode: ['', [Validators.required]]
        });

        this.getCurrentNotificationsConfig();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    onSubmitAuthCode(): void {
        if (this.authCodeForm.valid) {
            const { authCode } = this.authCodeForm.value;
            this.profile.telegram_chat_id = authCode;
            this.updateProfile();
        }
    }

    private getCurrentNotificationsConfig(): void {
        this.appConfigsService.getCurrentNotificationsConfig().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.isUpdateEmailSettings = resp.data.is_email;
                this.isUpdateTelegramSettings = resp.data.is_telegram;
            }
        });
    }

    private updateProfile(): void {
        this.accountService.patchProfile(this.profile).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.error) {
                    this.accountService.profile.next(resp.data);
                    const msg = 'Вы успешно подписались на Telegram рассылку';
                    this.handlerService.successMsg(msg);
                }
            },
            (error: HttpErrorResponse) => {
                this.handlerService.errorMsg(`${error.status} ... ${error.message}`);
                return throwError(error);
            }
        );
    }

    private updateNotificationsConfig(notificationType, status): void {
        const data = {
            userId: this.profile.user.id,
            notificationType,
            status: status ? 1 : 0
        };
        this.appConfigsService.updateNotificationsConfig(data).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                const msg = 'Настройки успешно обновлены';
                this.handlerService.successMsg(msg);
            }
        });
    }

    telegramCheckboxHandler(): void {
        this.isUpdateTelegramSettings = !this.isUpdateTelegramSettings;
        this.updateNotificationsConfig('telegram', this.isUpdateTelegramSettings);
    }

    emailCheckboxHandler(): void {
        this.isUpdateEmailSettings = !this.isUpdateEmailSettings;
        this.updateNotificationsConfig('email', this.isUpdateEmailSettings);
    }
}
